import React, { useState } from 'react';
import { Modal, Box, Typography, Button, IconButton, Snackbar, Alert, CircularProgress } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { grey, red } from '@mui/material/colors';
import BASE_URL from '../../config';

const style = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 400 }, bgcolor: 'white', borderRadius: 4, p: 4, outline: 'none', textAlign: 'center'
};

export default function DeleteUserPop({ user, refresh }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleDelete = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/users/${user.id}`, {
        method: 'DELETE',
      });
      
      if (res.ok) {
        setSnackbar({ open: true, message: 'Usuario eliminado correctamente', severity: 'success' });
        setTimeout(() => {
          setOpen(false);
          refresh(); // Recarga la tabla de usuarios
        }, 1200);
      } else {
        const data = await res.json();
        setSnackbar({ open: true, message: data.message || 'Error al eliminar', severity: 'error' });
        setLoading(false);
      }
    } catch (e) {
      setSnackbar({ open: true, message: 'Error de conexión', severity: 'error' });
      setLoading(false);
    }
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)} 
      sx={{'&:hover': {color:grey[100], bgcolor: red[400] } }}>
        <DeleteIcon fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={() => !loading && setOpen(false)}>
        <Box sx={style}>
          <Typography variant="h6" textAlign={'left'} mb={1}>{`¿Eliminar el usuario ${user.nombre_completo}?`}</Typography>
          <Typography variant="body1" color='textSecondary' mb={3} textAlign={'left'}>
            Esta acción no se puede deshacer. ¿Estás seguro que deseas eliminar este usuario permanentemente?
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'right' }}>
            <Button 
              variant="contained" 
              disabled={loading}
              sx={{ 
                color: 'black', 
                bgcolor: grey[100], 
                textTransform: 'none', 
                borderRadius: '8px',
                width: { xs: '50%', sm: '40%' },
                '&:hover': { bgcolor: grey[200] }
              }} 
              onClick={() => setOpen(false)}
            >
              No, cancelar
            </Button>
            <Button 
              variant="contained" 
              disabled={loading}
              sx={{ 
                bgcolor: red[500], 
                color: 'white',
                '&:hover': { bgcolor: red[700] }, 
                textTransform: 'none', 
                borderRadius: '8px',
                width: { xs: '50%', sm: '40%' } 
              }} 
              onClick={handleDelete}
            >
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Sí, eliminar'}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000} 
        onClose={() => setSnackbar({ ...snackbar, open: false })} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}